import React from 'react';
import { footerLinks } from '../mock';
import { ArrowRight } from 'lucide-react';

const ImajiLogo = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" className="flex-shrink-0">
    <defs>
      <linearGradient id="ig" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#c084fc" />
        <stop offset="100%" stopColor="#7c3aed" />
      </linearGradient>
    </defs>
    <circle cx="13" cy="13" r="13" fill="url(#ig)" />
    <circle cx="9" cy="11" r="2" fill="#0b0b0e" />
    <circle cx="17" cy="11" r="2" fill="#0b0b0e" />
    <path d="M9 17 Q13 20 17 17" stroke="#0b0b0e" strokeWidth="1.6" fill="none" strokeLinecap="round" />
  </svg>
);

export default function Footer() {
  return (
    <footer id="demo" className="relative border-t border-white/5 pt-24 pb-12 text-white overflow-hidden">
      <div className="halftone" />
      <div className="relative mx-auto max-w-[1400px] px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-6 space-y-6">
            <h3 className="h-display text-[46px] md:text-[62px] leading-[1.02] max-w-[560px]">
              Ready to run every aisle from one brain?
            </h3>
            <p className="text-white/60 text-[15px] max-w-[440px]">
              Book a 20-minute walkthrough. We&rsquo;ll show your store, on your data, running on
              Grocera.
            </p>
            <div className="flex flex-wrap gap-3">
              <a
                href="https://calendar.app.google/rUCGByUhUwE69b2T9"
                target="_blank"
                rel="noreferrer"
                className="btn-primary"
              >
                Book a Demo <ArrowRight size={16} />
              </a>
              <a href="/tbs-dashboard" className="btn-ghost">
                Open Dashboard
              </a>
            </div>
          </div>

          <div className="lg:col-span-6 grid grid-cols-3 gap-6">
            {Object.entries(footerLinks).map(([group, items]) => (
              <div key={group}>
                <p className="eyebrow mb-4">{group}</p>
                <ul className="space-y-3">
                  {items.map((it) => (
                    <li key={it}>
                      <a href="#" className="text-white/70 hover:text-white text-[14px] transition-colors">
                        {it}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="divider my-16" />

        {/* imajiai.space company card */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-5">
            <div className="border border-white/10 rounded-md p-6 bg-white/[0.02]">
              <div className="flex items-center gap-3 mb-4">
                <ImajiLogo />
                <div className="text-[18px] tracking-tight">
                  imajiai<span className="text-[#c084fc]">.space</span>
                </div>
              </div>
              <p className="text-white/70 text-[14px] leading-[1.65] mb-5">
                imajiai builds autonomous AI products for Asia&rsquo;s retail and content
                operators.
              </p>
              <div className="mono text-[11.5px] text-white/45 leading-[1.7]">
                IMAJI AI PTE. LTD.<br />
                UEN 202615181W<br />
                22 Sin Ming Lane, #06-76<br />
                Midview City, Singapore 573969
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pt-3">
            <p className="eyebrow mb-3">Built by</p>
            <p className="text-white/70 text-[14.5px] leading-[1.7] max-w-[520px]">
              Grocera is a product of <a href="https://imajiai.space" target="_blank" rel="noreferrer" className="text-white hover:text-[#c084fc] transition-colors">imajiai.space</a>. Our mission is to bring
              autonomous AI to the operational backbone of Asia&rsquo;s retail, media and content
              businesses.
            </p>
          </div>
        </div>

        <div className="divider my-12" />

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="flex items-center gap-2">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="1.2" />
              <circle cx="12" cy="12" r="3" fill="currentColor" />
            </svg>
            <span className="text-[14px] tracking-tight">grocera</span>
            <span className="mono text-[10.5px] text-white/40 ml-3">an imajiai product</span>
          </div>
          <p className="text-white/45 text-[12.5px]">
            &copy; {new Date().getFullYear()} Imaji AI Pte. Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
